import Image from '../../../components/Image';
import { cleanBookTitle } from '../../Homepage/Contexts/DiffitBooksContext';

/**
 * Clickable card displaying a book's cover image, title, and author.
 * @param {Object} props
 * @param {Object} props.book - Book object with title, author, and cover properties.
 * @param {Function} props.onClick - Callback invoked with the book object when the card is clicked.
 */
export const BookCard = ({ book, onClick }) => {
  const cleanedTitle = cleanBookTitle(book.title);

  return (
    <button
      onClick={() => onClick(book)}
      className='group flex flex-col items-center p-4 rounded-xl border border-transparent hover:border-gray-200 hover:bg-gray-50 transition-all bg-white text-left'>
      <div className='w-full aspect-[2/3] mb-3 flex items-center justify-center'>
        <Image
          src={book.cover}
          alt={cleanedTitle}
          className='max-h-full max-w-full object-contain rounded shadow-sm'
        />
      </div>
      <div className='w-full min-w-0'>
        <p className='text-sm font-medium text-gray-900 line-clamp-3' title={cleanedTitle}>
          {cleanedTitle}
        </p>
        <p className='text-xs text-gray-500 truncate mt-0.5' title={book.author}>
          {book.author}
        </p>
      </div>
    </button>
  );
};
